import React from 'react';
import { View, StyleSheet } from 'react-native';
import { useThemeColors } from '@/hooks/residents/useThemeColors';

interface DragHandleProps {
  /**
   * When false the pill is invisible but still occupies its 4pt, so the
   * handle block keeps the same 16pt footprint. Sheets pass false where
   * pan-to-dismiss is unavailable (web) to stay pixel-aligned with native
   * without advertising a gesture that does nothing.
   */
  showPill?: boolean;
}

export const DragHandle: React.FC<DragHandleProps> = ({ showPill = true }) => {
  const { colors } = useThemeColors();
  return (
    <View style={styles.container}>
      <View
        style={[
          styles.handle,
          { backgroundColor: colors.card.border },
          !showPill && styles.hiddenPill,
        ]}
      />
    </View>
  );
};

const styles = StyleSheet.create({
  container: {
    alignItems: 'center',
    paddingTop: 8,
    paddingBottom: 4,
  },
  handle: {
    width: 36,
    height: 4,
    borderRadius: 2,
  },
  hiddenPill: {
    opacity: 0,
  },
});
